export const ReviewsFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for customer reviews (e.g. 'Customer Testimonials')",
      seo: true,
      key: "reviews.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief intro to reviews section (10-15 words)",
      seo: true,
      key: "reviews.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Grid", value: "grid" },
      { label: "Carousel", value: "carousel" },
      { label: "Wall", value: "wall" },
      { label: "Spotlight (one featured quote)", value: "spotlight" },
    ],
    metadata: {
      source: "manual",
    },
  },
  showRatings: {
    type: "radio",
    label: "Show Star Ratings",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  showDates: {
    type: "radio",
    label: "Show Dates",
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  useRealReviews: {
    type: "radio",
    label: "Use Real Reviews",
    options: [
      { label: "Yes (fetch from database)", value: "yes" },
      { label: "No (use manual reviews below)", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  reviewLimit: {
    type: "number",
    label: "Number of Reviews to Display",
    min: 1,
    max: 50,
    metadata: {
      source: "manual",
    },
  },
  reviews: {
    type: "array",
    label: "Reviews",
    metadata: {
      source: "context",
      contextKey: "business.reviews",
      description: "Customer reviews from GMB/database",
      seo: true,
      key: "reviews.samples",
    },
    getItemSummary: (item: { name: string }) => item.name || "New Review",
    arrayFields: {
      name: {
        type: "text",
        label: "Customer Name",
      },
      location: {
        type: "text",
        label: "Location (optional)",
      },
      rating: {
        type: "number",
        label: "Rating (1-5)",
        min: 1,
        max: 5,
      },
      text: {
        type: "textarea",
        label: "Review Text",
      },
      date: {
        type: "text",
        label: "Date (optional)",
      },
    },
    defaultItemProps: {
      name: "John Doe",
      location: "",
      rating: 5,
      text: "Excellent service! Highly recommend.",
      date: "",
    },
  },
  minRating: {
    type: "radio",
    label: "Minimum Star Rating",
    options: [
      { label: "Any (1★+)", value: 1 },
      { label: "2★+", value: 2 },
      { label: "3★+", value: 3 },
      { label: "4★+", value: 4 },
      { label: "5★ only", value: 5 },
    ],
    metadata: {
      source: "manual",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
